// extracted by mini-css-extract-plugin
export default {"fullScreenLoader":"upCikGdfFKvSvcHlMJX8","fullScreenLoaderWrapper":"DKM90TZJyVj_4vaiEKLo"};